import React from "react";
import AcquireWebComponent from "../framework/MaterialUI";
import { Row, Col } from "../framework/Grid/";
import { Dialog } from "material-ui";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";

class ServiceContact extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      openContactForm: false,
      subject: "",
      comments: "",
      showSuccessSendForm: false,
    };
  }

  onContactFormSubmit(e) {
    e.preventDefault();
    const postData = {
      clientId: this.props.selected_client,
      subject: this.state.subject.trim(),
      comment: this.state.comments.trim(),
      originationPage: this.props.pageSource,
    };

    this.props.sendAssistRequest(postData);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.request_assist_successful === true &&
      isUndefined(this.props.request_assist_successful) &&
      this.state.openContactForm
    ) {
      this.setState({
        subject: undefined,
        comments: undefined,
        showSuccessSendForm: true,
        openContactForm: false,
      });
    }
  }

  render() {
    const actionButtons = [
      this.props.send_assist_request_error && (
        <div
          className="pull-left ml-20 mt-5"
          style={{ fontWeight: "bold", color: "#FF0000" }}
        >
          {this.props.send_assist_request_error}
        </div>
      ),
      <button
        onClick={() => {
          this.setState({ openContactForm: false });
        }}
        className="btn btn-default btn-aa-info mr-10"
      >
        Cancel
      </button>,
      isEmpty(this.state.comments) || isEmpty(this.state.subject) ? (
        <button disabled className="btn btn-default btn-aa-info mr-10">
          Submit
        </button>
      ) : (
        <button
          onClick={e => {
            this.onContactFormSubmit(e);
          }}
          className="btn btn-aa-default mr-10"
        >
          Submit
        </button>
      ),
    ];
    const { className, style } = this.props;
    return (
      <div className={className} style={style} id="cs_contact_form">
        <a
          onClick={e => {
            e.preventDefault();
            this.setState({ openContactForm: true });
          }}
        >
          Click here
        </a>{" "}
        {this.props.messageText ||
          "to contact your client services representative to discuss ways to engage this audience."}
        <Dialog
          open={this.state.openContactForm}
          contentStyle={{ width: "540px" }}
          titleClassName={"support-form-title"}
          bodyClassName={"support-form-body"}
          actionsContainerClassName={"support-form-action-container"}
          title={"CONTACT US"}
          modal={true}
          actions={actionButtons}
        >
          <Row className="no-padding-left no-padding-right no-padding-bottom pt-10 no-margin-bottom">
            <Col xs="3" sm="3" md="3" lg="3" className="pt-10">
              <strong>Subject</strong>
            </Col>
            <Col xs="9" sm="9" md="9" lg="9">
              <input
                type="text"
                style={{ width: "100%" }}
                value={this.state.subject}
                maxLength="65"
                onChange={e => {
                  this.setState({ subject: e.target.value });
                }}
              />
            </Col>
          </Row>
          <Row className="no-padding-left no-padding-right no-padding-bottom no-margin-bottom">
            <Col xs="3" sm="3" md="3" lg="3" className="pt-10">
              <strong>Comments</strong>
            </Col>
            <Col xs="9" sm="9" md="9" lg="9">
              <textarea
                className="comment-box"
                value={this.state.comments}
                maxLength="500"
                onChange={e => {
                  this.setState({ comments: e.target.value });
                }}
              />
            </Col>
          </Row>
        </Dialog>
        <Dialog
          open={this.state.showSuccessSendForm}
          onRequestClose={() => {
            this.setState({ showSuccessSendForm: false });
          }}
          contentStyle={{ width: "350px", padding: "20px" }}
          modal={true}
        >
          <div
            style={{ fontSize: "16px", fontFamily: "Arial", color: "#000" }}
            className="text-center"
          >
            Your message has been sent.
          </div>
          <div
            style={{ fontSize: "15px", fontFamily: "Arial", color: "#000" }}
            className="text-center mt-10"
          >
            Your client services representative will contact you within one
            business day.
          </div>
          <div className="text-center mt-20">
            <button
              className="btn btn-aa-default"
              onClick={() => {
                this.setState({ showSuccessSendForm: false });
              }}
            >
              CLOSE
            </button>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ServiceContact;



// WEBPACK FOOTER //
// ./src/components/Insights/ServiceContact.jsx